import PropTypes from 'prop-types';
import React, { Component } from 'react';

import CommonPropTypes from '../../../app/constants/PropTypes';
import ErrorPage from '../ErrorPage';

import Tools from './Tools.svg';

export default class ServerError extends Component {
  static propTypes = {
    homeLink: CommonPropTypes.link.isRequired,
    history: CommonPropTypes.history,
    statusCode: PropTypes.number,
  };

  static defaultProps = {
    statusCode: 500,
  };

  render() {
    return (
      <ErrorPage
        homeLink={this.props.homeLink}
        heading="*whistles* Nothing to see here!"
        image={Tools}
        primaryMessage="This is embarrassing... something went wrong"
        statusCode={this.props.statusCode}
        supportMessage="if this problem doesn't resolve itself"
        title="Server error"
      />
    );
  }
}
